import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";


gsap.registerPlugin(ScrollTrigger, Observer);

//***** SCROLL TRIGGER */ 

// What we do subpages
let firstPanel = document.querySelector(".first-panel");
let imageScroll = document.querySelector(".content-image-panel_image.image-scroll");
if (imageScroll) {
  gsap.to(imageScroll, {
    scrollTrigger: {
      trigger: firstPanel,
      start: 'bottom 35%',
      end: '+=500',
      scrub: true,
    },
    yPercent: 40,
  });
}